import React, { useState } from "react";
import Map, { Source, Layer, Popup, NavigationControl } from "react-map-gl";
import data from "../data.json";
import "./TrafficIndex.css";
import Axios from "axios";
import RiseLoader from "react-spinners/RiseLoader";
import { css } from "@emotion/react";
import legend from "./legend.png";
// import moment from "moment";
import imsc from "./imsc.png";

const override = css`
  position: absolute;
  z-index: 10;
  bottom: 2rem;
  right: 1rem;
`;

const layerStyle = {
  id: "polygon",
  type: "fill",
  paint: {
    "fill-color": {
      type: "identity",
      property: "color",
    },
    "fill-outline-color": "rgba(200, 100, 240, 1)",
    "fill-opacity": 0.5,
  },
};

function TrafficIndexZone() {
  const [lat, setlat] = useState(34.0224);
  const [long, setlong] = useState(-118.2851);
  const [date, setdate] = useState("2018-03-01");
  const [time, settime] = useState("19:00");
  const [method, setmethod] = useState("IDW Interpolation");
  const [jdata, setjdata] = useState(data);
  const [orignal, setorignal] = useState(data);
  const [speed, setspeed] = useState(10);
  const [loading, setLoading] = useState(false);
  const [zoneid, setzoneid] = useState(670);
  const [congestion, setcongestion] = useState("Standstill");
  const [numbergridpoints, setnumbergridpoints] = useState(0);
  const handleOnClick = (event) => {
    var temp = JSON.parse(JSON.stringify(orignal));
    for (var i = 1; i <= temp["features"].length; i++) {
      if (
        temp["features"][i]["properties"]["OBJECTID"] ===
        event.features[0]["properties"]["OBJECTID"]
      ) {
        temp["features"][i]["properties"]["color"] = "#4f97b7";
        break;
      }
      setzoneid(event.features[0]["properties"]["OBJECTID"]);
      setspeed(event.features[0]["properties"]["speed"]);
      setcongestion(event.features[0]["properties"]["congestion"]);
      setnumbergridpoints(
        event.features[0]["properties"]["number_grid_points"]
      );
    }
    setjdata(temp);
    setlat(event.lngLat.lat);
    setlong(event.lngLat.lng);
  };
  return (
    <div>
      <RiseLoader
        color={"#990000"}
        loading={loading}
        size={20}
        css={override}
      />
      <input
        class="input1"
        type="date"
        // max={moment().format("YYYY-MM-DD")}
        min="2018-03-01"
        max="2018-03-04"
        value={date}
        onChange={(event) => {
          setdate(event.target.value);
        }}
      ></input>
      <input
        class="input2"
        type="time"
        value={time}
        step="3600"
        onChange={(event) => {
          settime(event.target.value);
        }}
      ></input>
      <button
        type="button"
        class="button1"
        onClick={() => {
          setLoading(true);
          Axios.post("/api/traffic/estimate/zone/", {
            Latitude: lat,
            Longitude: long,
            Date: date,
            Time: time,
            Method: method,
          }).then((response) => {
            setLoading(false);
            setjdata(response.data);
            setorignal(response.data);
          });
        }}
      >
        Submit
      </button>
      <select
        class="select2"
        onChange={(event) => {
          setmethod(event.target.value);
        }}
      >
        <option value="IDW Interpolation">IDW Interpolation</option>
        <option value="Kriging Interpolation">Kriging Interpolation</option>
        <option value="Nearest Neighbour">Nearest Neighbour</option>
      </select>
      <img class="img1" src={imsc} alt="" />
      <img class="img2" src={legend} alt="" />
      <Map
        initialViewState={{
          longitude: long,
          latitude: lat,
          zoom: 12,
        }}
        interactiveLayerIds={["polygon"]}
        interactive={true}
        onClick={handleOnClick}
        style={{ width: "100vw", height: "100vh" }}
        mapStyle="mapbox://styles/mapbox/streets-v9"
        mapboxAccessToken="pk.eyJ1IjoiY2FuYXN0YXNpb3UiLCJhIjoiY2w0ZXowc2ZiMDc0bDNqbzFxZWp6M2ttciJ9.AlAcpimbT_J99eRS_dYKog"
      >
        <Source id="my-data" type="geojson" data={jdata}>
          <Layer {...layerStyle} />
        </Source>
        <Popup
          longitude={long}
          latitude={lat}
          closeOnClick={false}
          anchor="left"
        >
          <div style={{ display: "inline" }}>
            <p class="h1">
              Census Tract ID: <span class="value">{zoneid}</span>
            </p>

            <p class="h1">
              Overall Congestion <span class="value">{congestion}</span>
            </p>
            <p class="h1">
              Estimated Speed: <span class="value">{speed} mph</span>
            </p>
            <p class="h1">
              Estimated Method: <span class="value">{method}</span>
            </p>
            <p class="h1">
              Number of grid points:{" "}
              <span class="value">{numbergridpoints}</span>
            </p>
          </div>
        </Popup>
        <NavigationControl />
      </Map>
    </div>
  );
}

export default TrafficIndexZone;
